// extracted by mini-css-extract-plugin
module.exports =  {"heading":"seom__LIwazOkHHEeFyF1QrnyA"};